import { get } from 'lodash';
import { useMemo } from 'react';

const arrayMap = <T extends Record<string, any>>(
  array: T[] = [],
  key: keyof T | string,
): Map<string, T> => {
  return new Map(array?.map((el) => [get(el, key), el]));
};

const useArrayMap = <T extends Record<string, any>>(
  array: T[] = [],
  key: keyof T | string,
): Map<string, T> => {
  return useMemo(() => arrayMap(array, key), [array, key]);
};

export { arrayMap, useArrayMap };